import { css } from 'aphrodite';
import { useState } from 'react';
import { Icon } from 'semantic-ui-react';

import stylesCommons from '../../StylesCommons';
import HoverablePopup from '../HoverablePopup';

interface CopyableTextState {
    isCopied: boolean;
}

interface CopyableTextProps {
    text: string;
    textToCopy: string;
}

export default function CopyableText(props: CopyableTextProps) {
    const [isCopied, setCopied] = useState<CopyableTextState>({ isCopied: false });
    const handleCopyClick = (textToCopy: string) => {
        navigator.clipboard.writeText(textToCopy).then(() => setCopied({ isCopied: true }));
    };

    const handleClose = () => setCopied({ isCopied: false });

    const getPopupText = () => (isCopied.isCopied ? 'Copied' : 'Copy to clipboard');

    const { text, textToCopy } = props;

    return (
        <span>
            {text}
            <HoverablePopup
                trigger={
                    <Icon
                        name="copy outline"
                        className={css(stylesCommons.copyableTextIcon)}
                        onClick={() => handleCopyClick(textToCopy)}
                    />
                }
                content={getPopupText()}
                onClose={handleClose}
            />
        </span>
    );
}
